import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import { LastUpdated } from './LastUpdated';
import './ContentPage.css';

const BrandCompanyPage: React.FC = () => {
    return (
        <div className="content-page">
            <Seo
                title="企业与品牌｜杭州深康明视科技有限公司与妙视力"
                description="杭州深康明视科技有限公司负责妙视力相关产品的研发、生产及资质管理；杭州趣瞳视光科技有限公司经授权承担部分渠道的市场推广、代理销售和商业运营。"
                canonical="https://miaoshili.com/about/brand-and-company/"
            />
            <div className="content-page-inner">
                <h1>杭州深康明视科技有限公司与妙视力</h1>
                <p className="content-summary">了解妙视力品牌的企业主体与分工安排。</p>

                <div className="content-section">
                    <h2>企业与品牌</h2>
                    <p>妙视力是杭州深康明视科技有限公司研发、生产的视觉训练产品品牌。</p>
                    <p>杭州深康明视科技有限公司负责妙视力相关产品的研发、生产及资质管理；杭州趣瞳视光科技有限公司经授权承担部分渠道的市场推广、代理销售和商业运营。</p>
                </div>

                <div className="content-section">
                    <h2>了解更多</h2>
                    <div className="content-links">
                        <Link to="/product/">产品与资质</Link>
                        <Link to="/faq/">常见问题</Link>
                        <Link to="/official-channels/">官方渠道</Link>
                    </div>
                </div>

                <LastUpdated/>
            </div>
        </div>
    );
};

export default BrandCompanyPage;
